<template>
  <div>
    <div id="gallery-thumb" class="carousel slide carousel-fade carousel-thumbnails list-gallery pt-2"
      data-ride="carousel">
      <!--Slides-->
      <div class="carousel-inner" role="listbox" :id="'my-gallery'">
        <a :class="i === 0 ? 'carousel-item active' : 'carousel-item'" v-for="(image, i) in images" :key="i"
          data-target="#gallery-thumb" :data-slide-to="i" :href="image.full_url" :data-pswp-width="1280"
          :data-pswp-height="720" data-cropped="true" target="_blank" rel="noreferrer">
          <img class="d-block w-100 carousel-img" :src="image.full_url" alt="slide" />
        </a>
      </div>
      <!--Controls starts-->
      <span class="d-lg-block d-md-block">
        <a class="carousel-control-prev carousel-control-gallery " href="#gallery-thumb" role="button"
          data-slide="prev">
          <span class="lnr lnr-chevron-left" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next carousel-control-gallery " href="#gallery-thumb" role="button"
          data-slide="next">
          <span class="lnr lnr-chevron-right" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </span>
    </div>
    <!--Controls ends-->
    <!--<ol class="gallery-images-container">
      <li v-for="(image, i) in images" data-target="#gallery-thumb"
        :key="i" :data-slide-to="i"
        :active_slide="active_slide"
        :class="i === active_slide ? 'gallery-image-c actived' : 'gallery-image-c'">
        <img :src="image.full_url"/> 
      </li>
    </ol>-->
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default {
  name: "Gallery",
  props: {
    images: Array,
  },
  setup(props) {
    return {
      imagesData: props.images,
    };
  },
  data: () => ({
    active_slide: 0,
  }),
  mounted() {
    let self = this;
    $('#gallery-thumb').on('slide.bs.carousel', function (slide) {
      self.active_slide = slide.to;
    })
    setTimeout(() => {
      $('.carousel').carousel()
    }, 2000);

    if (!this.lightbox) {
      console.log('entra');
      this.lightbox = new PhotoSwipeLightbox({
        gallery: '#my-gallery',
        children: 'a',
        pswpModule: () => import('photoswipe'),
      });
      this.lightbox.init();
    }

  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
};
</script>

<style scoped>
.gallery-images-container {
  display: flex;
  width: 100%;
  overflow: auto;
  overflow-y: hidden;
  height: 85px;
  padding-left: 0px;
  margin-bottom: 0px;
}

.gallery-image-c {
  cursor: pointer;
  padding-top: 10px;
  height: 74px !important;
  margin-right: 5px;
  flex: 0 0 auto;
  box-sizing: border-box;
  opacity: 0.5;
}

.gallery-image-c.actived {
  opacity: 1 !important;
}

.gallery-image-c img {
  width: 90px !important;
  height: 64px !important;
}

.clearfix {
  clear: both;
}

.carousel-indicators {
  position: initial !important;
  margin-top: 1rem !important;
  justify-content: start;
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 0px;
}

.carousel-indicators li {
  height: 100%;
  max-height: 4rem;
  width: 15% !important;
  margin-left: 0px;
  margin-right: 0px;
}

.carousel-indicators li::after {
  height: 0px;
}

.carousel-control-gallery>span {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 900;
}

.carousel-img {
  height: 26rem;
}

.list-gallery-thumb {
  padding: 0px;
}

.carousel-indicators li {
  padding-left: 8px;
  padding-right: 8px;
}

.carousel-indicators li:nth-child(1n) {
  padding-left: 0px;
}

@media (max-width: 960px) {
  .carousel-img {
    height: 24rem;
  }

  .carousel-control-gallery>span {
    width: 45px;
    height: 45px;
    font-size: 1.25rem;
  }

  .carousel-indicators li {
    width: 33.2% !important;
  }

  .carousel-indicators li {
    padding-right: 8px !important;
  }

}

@media (max-width: 512px) {
  .carousel-img {
    height: 12rem;
  }

  .carousel-indicators li {
    width: 33.2% !important;
  }

  .carousel-indicators {
    display: flex;
    flex-wrap: wrap;
    height: 9rem;
  }

  #gallery {
    padding-bottom: 0 !important;
  }

  .carousel-indicators li {
    padding-left: 8px;
    padding-right: 8px;
  }

  .carousel-indicators li:nth-child(1n) {
    padding-left: 0px !important;
  }

  .carousel-indicators li:nth-child(3n) {
    padding-right: 0px !important;
  }
}

@media (max-width: 480px) {
  .gallery-images-container {
    height: 74px;
  }
}
</style>
